var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.158,
    height: 27.004,
    viewBox: "0 0 27.158 27.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5192",
    "data-name": "Group 5192",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    d: "M4174.6,261.412c0,.333,0,.644,0,.956,0,.543,0,1.086.008,1.629a1.684,1.684,0,0,0,1.249,1.566,1.717,1.717,0,0,0,1.85-.623,1.753,1.753,0,0,0,.341-1.068c0-.789,0-1.577,0-2.364,0-.026,0-.05,0-.085h13.159v.4c0,.711-.008,1.423.005,2.134a1.724,1.724,0,0,0,3.208.831,1.616,1.616,0,0,0,.232-.881c-.008-.411,0-.823,0-1.233v-1.259h.493c.728,0,1.457,0,2.183,0a.838.838,0,0,1,.876.894q0,2.764,0,5.526v9.984q0,3.417,0,6.836a3.036,3.036,0,0,1-.011.384.835.835,0,0,1-.837.72c-.806,0-1.611,0-2.417,0h-10.178l-3.792,0-6.669,0c-.793,0-1.586-.015-2.378,0a.906.906,0,0,1-.876-.881c.013-2.064.006-4.129.006-6.194q0-4.2,0-8.391c0-1.211,0-2.424,0-3.636q0-2.186,0-4.369a.827.827,0,0,1,.881-.885c.839,0,1.678,0,2.518,0Zm10,23.229h.191l3.728.007c.848,0,1.7,0,2.543,0,.957,0,1.911-.007,2.867-.007.774,0,1.55.007,2.327.007a.77.77,0,0,0,.836-.839V280.4q0-3.176,0-6.348,0-3.1,0-6.194a.783.783,0,0,0-.86-.86c-.844,0-1.688,0-2.531,0q-2.5,0-5-.008c-.84,0-1.68.008-2.521.008q-2.914,0-5.833-.008c-.719,0-1.439.008-2.158.008q-2.6,0-5.206,0a.769.769,0,0,0-.819.82c0,.826,0,1.652,0,2.48q0,3.186,0,6.373,0,3.561,0,7.119a.757.757,0,0,0,.829.842c1.268,0,2.536,0,3.8,0l3.47.007c.62,0,1.241,0,1.863-.007Z",
    transform: "translate(-4171.052 -258.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M4183.88,262.908c0-.68,0-1.361,0-2.041a1,1,0,0,1,.533-.945.972.972,0,0,1,1.08.055.954.954,0,0,1,.431.818q0,1.625-.006,3.249c0,.337.015.676-.018,1.011a1,1,0,0,1-.945.849,1.018,1.018,0,0,1-1.007-.667,1.306,1.306,0,0,1-.061-.364c-.005-.655,0-1.311,0-1.966Z",
    transform: "translate(-4163.017 -259.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M4175.7,262.8c0,.732.01,1.465-.005,2.2a1,1,0,0,1-.8.886,1.025,1.025,0,0,1-1.093-.493,1.092,1.092,0,0,1-.132-.542c0-1.332,0-2.662,0-3.994a1.024,1.024,0,0,1,.971-1.06,1.006,1.006,0,0,1,1.067.976c0,.677,0,1.353,0,2.029Z",
    transform: "translate(-4169.416 -259.784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M4181.529,272.893c0-.533-.008-1.067,0-1.6.011-.571.24-.846.79-.857q1.679-.034,3.357,0a.739.739,0,0,1,.78.823q.018,1.624,0,3.251a.777.777,0,0,1-.827.849c-1.083.021-2.167.02-3.252,0a.774.774,0,0,1-.847-.872C4181.521,273.958,4181.529,273.424,4181.529,272.893Z",
    transform: "translate(-4164.491 -253.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M4174.057,269.1c0-.515-.009-1.029,0-1.545.012-.555.262-.849.793-.857q1.677-.029,3.354,0a.729.729,0,0,1,.776.821q.015,1.622,0,3.247a.755.755,0,0,1-.816.846c-1.1.023-2.2.024-3.3,0-.538-.011-.793-.314-.8-.859S4174.057,269.651,4174.057,269.1Z",
    transform: "translate(-4169.172 -255.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M4180.248,266.688c.517,0,1.03-.008,1.545,0,.625.013.918.293.925.906q.015,1.568,0,3.14a.79.79,0,0,1-.851.88c-1.081.02-2.166.021-3.247,0-.564-.011-.824-.307-.829-.888q-.014-1.6,0-3.194a.733.733,0,0,1,.809-.839c.548-.02,1.1,0,1.647,0Z",
    transform: "translate(-4166.834 -255.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M4174.057,272.848c0-.533-.01-1.067,0-1.6a.735.735,0,0,1,.787-.813q1.679-.032,3.359,0a.725.725,0,0,1,.773.82q.018,1.627,0,3.252a.763.763,0,0,1-.814.85q-1.652.034-3.3,0a.763.763,0,0,1-.8-.86C4174.049,273.948,4174.057,273.4,4174.057,272.848Z",
    transform: "translate(-4169.174 -253.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M4182.725,272.874c0,.533.008,1.067,0,1.6-.011.572-.276.876-.833.888-1.083.021-2.168.02-3.251,0a.78.78,0,0,1-.841-.881c-.006-1.067-.008-2.132,0-3.2a.745.745,0,0,1,.806-.849q1.652-.032,3.3,0c.546.01.8.293.813.841S4182.725,272.342,4182.725,272.874Z",
    transform: "translate(-4166.828 -253.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M4184.018,266.688c.515,0,1.031-.01,1.544,0,.6.015.892.294.9.876q.018,1.6,0,3.194a.772.772,0,0,1-.822.85q-1.649.034-3.3,0c-.535-.011-.795-.309-.8-.857q-.015-1.624,0-3.247a.72.72,0,0,1,.781-.81c.567-.023,1.136-.007,1.7-.007Zm1.457.985h-2.949v2.95h2.949Z",
    transform: "translate(-4164.491 -255.465)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/DateIcon.aa365c6fcae83adea1d230d89f8f0e11.svg";
export { ForwardRef as ReactComponent };